import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import MediaQuery from "react-responsive";
import {
  getVarsoUrl,
  cropNumber,
  getAlleleFrequency,
  renderMainDataPoint,
} from "../../../../common/helpers/helpers";
import { kaviarListSelector } from "../../../../state/selectors/Kaviar.selectors";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import { islamicGreen, redColor } from "../../../../common/helpers/colors";
import HelperText from "../../../../components/atoms/HelperText";

class Kaviar extends React.Component {
  getFrequencyColor = (ac, an) => {
    let freq;
    let color;
    let weight;
    if (ac && an) {
      freq = (ac / an) * 100;
      if (freq > 5) {
        color = islamicGreen;
        weight = "bold";
      } else if (freq < 0.01) {
        color = redColor;
        weight = "bold";
      }
    }
    return { color, weight };
  };

  getTotalFrequencyColor = (frequency) => {
    let freq;
    let color;
    let weight;
    if (frequency) {
      freq = frequency * 100;
      if (freq > 5) {
        color = islamicGreen;
        weight = "bold";
      } else if (freq < 0.01) {
        color = redColor;
        weight = "bold";
      }
    }
    return { color, weight };
  };

  getTableMobile(item) {
    let tableMobile;
    let freqStyle;

    if (Array.isArray(item.ac) && item.ac.length > 1) {
      const sum = this.calculateSumAlleleFrequency(item);
      const acSum = this.calculateAlleleCountSum(item);
      const totalFreqStyle = this.getTotalFrequencyColor(sum);

      tableMobile = (
        <div>
          {item.ac.map((ac, j) => {
            const alleleCount = ac.value;
            let alleleNumber = null;
            if (Array.isArray(item.an) && item.an.length !== 0) {
              alleleNumber = item.an[j] && item.an[j].value;
            }
            freqStyle = this.getFrequencyColor(alleleCount, alleleNumber);
            return (
              <dl key={ac.id} className="dl-horizontal varsome-dl-horizontal">
                <dt className="col-9 col-xs-9">Allele Count</dt>
                <dd className="col-3 col-xs-3">{alleleCount || "-"}</dd>
                <dt className="col-9 col-xs-9">Allele Number</dt>
                <dd className="col-3 col-xs-3">{alleleNumber || "-"}</dd>
                <dt className="col-9 col-xs-9">Allele Frequency</dt>
                <dd className="col-3 col-xs-3">
                  {alleleCount && alleleNumber
                    ? getAlleleFrequency(
                        alleleCount / alleleNumber,
                        4,
                        freqStyle.color,
                        freqStyle.weight
                      )
                    : "-"}
                </dd>
              </dl>
            );
          })}
          <dl key="totals" className="dl-horizontal varsome-dl-horizontal">
            <dt className="col-3 col-xs-3">Totals</dt>
            <dt className="col-9 col-xs-9">Allele Count</dt>
            <dd className="col-3 col-xs-3">{acSum || "-"}</dd>
            <dt className="col-9 col-xs-9">Allele Frequency</dt>
            <dd className="col-3 col-xs-3">
              {getAlleleFrequency(
                sum,
                4,
                totalFreqStyle.color,
                totalFreqStyle.weight
              )}
            </dd>
          </dl>
        </div>
      );
    } else {
      let alleleCount = null;
      let alleleNumber = null;
      if (Array.isArray(item.ac) && item.ac.length !== 0) {
        alleleCount = item.ac[0].value;
      }
      if (Array.isArray(item.an) && item.an.length !== 0) {
        alleleNumber = item.an[0].value;
      }
      freqStyle = this.getFrequencyColor(alleleCount, alleleNumber);
      tableMobile = (
        <div>
          <dl className="dl-horizontal varsome-dl-horizontal">
            <dt className="col-9 col-xs-9">Allele Count</dt>
            <dd className="col-3 col-xs-3">{alleleCount || "-"}</dd>
            <dt className="col-9 col-xs-9">Allele Number</dt>
            <dd className="col-3 col-xs-3">{alleleNumber || "-"}</dd>
            <dt className="col-9 col-xs-9">Allele Frequency</dt>
            <dd className="col-3 col-xs-3">
              {item.ac && item.an
                ? getAlleleFrequency(
                    alleleCount / alleleNumber,
                    4,
                    freqStyle.color,
                    freqStyle.weight
                  )
                : "-"}
            </dd>
          </dl>
        </div>
      );
    }
    return tableMobile;
  }

  getTableHeaders = () => {
    const headers = (
      <thead>
        <tr>
          <th>Allele Count</th>
          <th>Allele Number</th>
          <th>Allele Frequency</th>
        </tr>
      </thead>
    );
    return headers;
  };

  getTableRow(item) {
    let rows = [];
    let freqStyle;

    if (Array.isArray(item.ac) && item.ac.length > 1) {
      rows.push(
        item.ac.map((ac, i) => {
          const alleleCount = ac.value;
          let alleleNumber = null;
          if (Array.isArray(item.an) && item.an.length !== 0) {
            alleleNumber = item.an[i] && item.an[i].value;
          }
          freqStyle = this.getFrequencyColor(alleleCount, alleleNumber);
          return (
            <tr key={ac.id}>
              <td>{alleleCount || "-"}</td>
              <td>{alleleNumber || "-"}</td>
              <td>
                {alleleCount && alleleNumber
                  ? getAlleleFrequency(
                      alleleCount / alleleNumber,
                      4,
                      freqStyle.color,
                      freqStyle.weight
                    )
                  : "-"}
              </td>
            </tr>
          );
        })
      );

      const sum = this.calculateSumAlleleFrequency(item);
      const acSum = this.calculateAlleleCountSum(item);
      const totalFreqStyle = this.getTotalFrequencyColor(sum);

      rows.push(
        <tr key="total">
          <td>
            <strong>{acSum}</strong>
          </td>
          <td />
          <td>
            <strong>
              {getAlleleFrequency(
                sum,
                4,
                totalFreqStyle.color,
                totalFreqStyle.weight
              )}
            </strong>
          </td>
        </tr>
      );
    } else {
      let alleleCount = null;
      let alleleNumber = null;
      if (Array.isArray(item.ac) && item.ac.length !== 0) {
        alleleCount = item.ac[0].value;
      }
      if (Array.isArray(item.an) && item.an.length !== 0) {
        alleleNumber = item.an[0].value;
      }
      freqStyle = this.getFrequencyColor(alleleCount, alleleNumber);
      rows = (
        <tr>
          <td>{alleleCount || "-"}</td>
          <td>{alleleNumber || "-"}</td>
          <td>
            {alleleCount && alleleNumber
              ? getAlleleFrequency(
                  alleleCount / alleleNumber,
                  4,
                  freqStyle.color,
                  freqStyle.weight
                )
              : "-"}
          </td>
        </tr>
      );
    }
    return rows;
  }

  calculateSumAlleleFrequency = (item) => {
    if (!Array.isArray(item.an) || item.an.length === 0) return null;

    let sum;
    if (item.ac.length > 1) {
      sum = 0;
      for (let i = item.ac.length - 1; i >= 0; i--) {
        sum += item.ac[i].value / item.an[0].value;
      }
    }
    return sum;
  };

  calculateAlleleCountSum = (item) => {
    let acSum;
    if (Array.isArray(item.ac) && item.ac.length > 0) {
      if (item.ac.length > 1) {
        let sum = 0;
        item.ac.forEach((ac) => {
          sum += ac.value;
        });
        acSum = cropNumber(sum);
      }
    }
    return acSum;
  };

  calculateMainData(item) {
    const res = cropNumber(this.calculateSumAlleleFrequency(item));
    return res ? `ƒ = ${res}` : item.main_data;
  }

  render() {
    const { kaviar } = this.props;
    if (kaviar) {
      const { version } = kaviar[0];
      const url = getVarsoUrl("http://db.systemsbiology.net/kaviar");
      const titleDetails = this.calculateMainData(kaviar[0]);
      const tmpl = kaviar.map((item) => {
        let acArray = false;
        if (Array.isArray(item.ac) && item.ac.length > 0) {
          if (item.ac.length > 1) {
            acArray = true;
          }
        }
        return (
          <div
            key={item.id}
            className="varsome-inner-container"
            data-testid="kaviar-container-header"
          >
            {acArray && (
              <div className="varsome-text-center">
                <small>
                  <i className="fa fa-info-circle" />
                  {
                    "  Kaviar has more than one entry for this variant and/or its equivalents"
                  }
                </small>
              </div>
            )}
            {item && (
              <div>
                <MediaQuery minWidth={768}>
                  <table className="varsome-table tw-mt-4">
                    {this.getTableHeaders()}
                    <tbody>{this.getTableRow(item)}</tbody>
                  </table>
                </MediaQuery>
                <MediaQuery maxWidth={767}>
                  {this.getTableMobile(item)}
                </MediaQuery>
              </div>
            )}
          </div>
        );
      });

      return (
        <div className="varsome-result-fixed" data-testid="kaviar-container">
          <div className="varsome-container varsome-container__basic">
            <ComponentPanel
              version={version}
              url={url}
              helperPopup={<HelperText fieldDescriptionKey="Kaviar" />}
              titleDetails={renderMainDataPoint(titleDetails)}
              content={tmpl}
              title="ISB Kaviar3"
            />
          </div>
        </div>
      );
    }

    return null;
  }
}

Kaviar.propTypes = {
  kaviar: PropTypes.arrayOf(
    PropTypes.shape({
      version: PropTypes.string,
      main_data: PropTypes.string,
    })
  ),
};

Kaviar.defaultProps = {
  kaviar: null,
};

const mapStateToProps = (state) => {
  return {
    kaviar: kaviarListSelector(state),
  };
};

export default connect(
  mapStateToProps,
  {}
)(withErrorGuard(Kaviar, "Kaviar", "ISB Kaviar3"));
